/**
 * Format number of milliseconds in more human readable format
 *
 * NOTE: This is similar to totalTime filter except
 *     for 0 it shows '0 mins' instead of '0'
 *     it shows up to 119 minutes before switching to hours
 *     it includes the 'hours' suffix ie '3 hours' rather than just '3'
 */
angular.module('core').filter('humanReadableDuration', ['numberFilter', 'minutesFilter',
  function($numberFilter, minutesFilter) {
    var MILLIS_PER_SECOND = 1000;
    var MILLIS_PER_HOUR = 60 * 60 * 1000;

    return function(milliseconds, unabbreviated) {
      if(_.isUndefined(milliseconds) || !_.isNumber(milliseconds) || isNaN(milliseconds)) {
        return minutesFilter(milliseconds, unabbreviated);
      }
      else {
        if (milliseconds >= 2 * MILLIS_PER_HOUR - 30 * MILLIS_PER_SECOND) {
          return $numberFilter(Math.round(10 * milliseconds / MILLIS_PER_HOUR) / 10) + ' hours';
        }

        return minutesFilter(milliseconds, unabbreviated);
      }
    };

  }
]);
